import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Input} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Input, {
            'value': this.get('value'),
            'ev-input': this.onInput
        }),
        _$ce(2, 'br'),
        _$cc(Input, {
            'frozenOnInput': true,
            'value': this.get('value'),
            'ev-input': this.onInput
        })
    ], 4 /* HasNonKeyedChildren */);
};